import {curry} from 'ramda';
import tryToCatch from 'try-to-catch';
import {createAction} from 'redux-actions';
import {
    getIngestSession,
    putIngestSession,
} from '@pluto/rest';
import {setNotificationAction} from '@pluto/notification';
import {restartIngestTaskAfterEditingAction} from '../../IngestList/Redux/IngestListActions';
import {DispatchAny} from '@pluto/@types';

import {IngestDataPayload} from '../IngestDataTypes';

export const INGEST_DATA_SET = 'INGEST_DATA_SET';
export const INGEST_DATA_RESET = 'INGEST_DATA_RESET';
export const PUT_JSON_DATA = 'PUT_JSON_DATA';

type IngestDataAction = Promise<IngestDataPayload>;

export const setIngestDataAction = createAction<IngestDataAction, number>(INGEST_DATA_SET, async (id: number) => {
    const res = await getIngestSession(id);

    return res.data;
});

export const putIngestDataAction = curry(async (id: string, jsonData: {[key: string]: any}, dispatch: DispatchAny) => {
    const [error, success] = await tryToCatch(putIngestSession, id, jsonData);

    if (error) {
        return dispatch(setNotificationAction({
            type: 'error',
            text: `JSON data hasn't been updated successfully`,
        }))
    }

    if (success.statusText === 'OK') {
        const {data} = success;

        restartIngestTaskAfterEditingAction(Number(id), dispatch);

        dispatch({
            type: INGEST_DATA_SET,
            payload: data,
        })

        return dispatch(setNotificationAction({
            type: 'success',
            text: 'JSON data has been successfully updated',
        }));
    }
});

export const resetIngestDataAction = createAction(INGEST_DATA_RESET);
